'use strict'

export default class Tabs {
  constructor () {
    $('.tabs__anchor').on('click', (event) => { this.switchTabs(event) })
  }

  switchTabs (event) {
    event.preventDefault()

    var tabs = $(event.currentTarget).parents('.tabs')
    var currTab = tabs.find('.tabs__list-item.--active')
    var currPanel = tabs.children('#' + currTab.attr('aria-controls'))
    var targetTab = $(event.currentTarget).parent()
    var targetPanel = tabs.children('#' + targetTab.attr('aria-controls'))

    currTab.removeClass('--active')
    currTab.attr({'aria-selected': 'false', 'aria-expanded': 'false'})
    targetTab.addClass('--active')
    targetTab.attr({'aria-selected': 'true', 'aria-expanded': 'true'})

    currPanel.removeClass('--active')
    currPanel.attr({'aria-hidden': 'true'})
    targetPanel.addClass('--active')
    targetPanel.attr({'aria-hidden': 'false'})
  }
}
